import styled from 'styled-components'
import Search from '.'
import BottomSlideModalWrapper from './BottomSlideModal'
import { SearchModalProps } from './search-types'

const BottomSlideModal = styled(BottomSlideModalWrapper)`
  & > div:first-child {
    border-radius: 0;
  }

  animation-name: searchModalOpen;
  animation-duration: 0.3s;
  animation-timing-function: ease-in;
  @keyframes searchModalOpen {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`

const SearchModal = (props: SearchModalProps) => {
  const { showModal, onBackAction } = props
  return (
    showModal && (
      <BottomSlideModal
        show={showModal}
        height="max-content"
        fullPage
        modalHeight="100%"
        contentHeight="100%"
        hideClose
        hideHeader>
        <Search isMobile onBackAction={onBackAction} />
      </BottomSlideModal>
    )
  )
}

export default SearchModal
